import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../core/services/auth.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {}
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn !== true) {
      //window.alert('Vous devez être connecté pour consulter cette page.');
      Swal.fire({
        title: 'Oups !',
        text: 'Vous devez être connecté pour consulter cette page.',
        icon: 'error',
        confirmButtonText: 'OK'
      })
      this.router.navigate(['login']);
    }
    return true;
  }
}